import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IAssessmentComponents,
  IAssessmentConfigs,
  IBulkLockStudentComponentScoresPayload,
  IBulkStudentScoresPayload,
  IBulkUnlockStudentScoresPayload,
  ICreateAssessmentComponentsPayload,
  ICreateAssessmentConfigPayload,
  IRecordStudentScoresPayload,
  IStudentScores,
  IUpdateAssessmentComponentPayload,
} from '../interfaces/assessment';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  constructor(private httpClient: HttpClient) {}

  getAssessmentConfigs(url: string, filters: any): Observable<IAssessmentConfigs> {
    return this.httpClient.get<IAssessmentConfigs>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAssessmentConfigs>;
  }

  bulkCreateAssessmentConfigs(
    url: string,
    payload: ICreateAssessmentConfigPayload,
  ): Observable<any> {
    return this.httpClient.post<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  getAssessmentComponents(url: string, filters: any): Observable<IAssessmentComponents> {
    return this.httpClient.get<IAssessmentComponents>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAssessmentComponents>;
  }

  createAssessmentComponents(
    url: string,
    payload: ICreateAssessmentComponentsPayload,
  ): Observable<any> {
    return this.httpClient.post<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  updateAssessmentComponent(
    url: string,
    payload: IUpdateAssessmentComponentPayload,
  ): Observable<any> {
    return this.httpClient.patch<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  deleteAssessmentComponent(url: string): Observable<any> {
    return this.httpClient.delete<any>(url, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  getStudentScores(url: string, filters: any): Observable<IStudentScores> {
    return this.httpClient.get<IStudentScores>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IStudentScores>;
  }

  createStudentScores(url: string, payload: IRecordStudentScoresPayload): Observable<any> {
    return this.httpClient.post<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  bulkLockStudentComponentScores(
    url: string,
    payload: IBulkLockStudentComponentScoresPayload,
  ): Observable<any> {
    return this.httpClient.patch<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  bulkLockStudentScores(
    url: string,
    payload: IBulkStudentScoresPayload,
  ): Observable<any> {
    return this.httpClient.patch<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  bulkUnlockStudentScores(
    url: string,
    payload: IBulkUnlockStudentScoresPayload,
  ): Observable<any> {
    return this.httpClient.patch<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  unlockStudentComponentScore(url: string, reason: string): Observable<any> {
    return this.httpClient.patch<any>(
      url,
      { reason },
      {
        headers: { accept: '*/*' },
      },
    ) as Observable<any>;
  }

  lockExamScore(url: string): Observable<any> {
    return this.httpClient.patch<any>(url, {}, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  unlockExamScore(url: string, reason: string): Observable<any> {
    return this.httpClient.patch<any>(
      url,
      { reason },
      {
        headers: { accept: '*/*' },
      },
    ) as Observable<any>;
  }

  finalizeAssessment(url: string, payload: any): Observable<any> {
    return this.httpClient.post<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  reopenAssessment(url: string, payload: any): Observable<any> {
    return this.httpClient.post<any>(url, payload, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
